import { NaviTableColumnDef } from '@cp/src/components/NaviTable/interfaces';
import { Button, Typography } from '@navi/web-ui/lib/primitives';
import {
  DateFormat,
  dateFormat,
  getFormattedDateWithYearAndTime,
  utcToIST
} from '@cp/src/utils/DateHelper';
import dayjs from 'dayjs';
import styles from './index.module.scss';
import { getReportTypeDisplayName, getTeamTypeDisplayName } from '../utils';

export const getConfigureReportColumnDefs = (
  onView: (row: any) => void
): NaviTableColumnDef<any, any>[] => [
  {
    accessorKey: 'baseReportType',
    header: 'Report',
    size: 200,
    cell: ({ row }) => {
      const data = row.original;
      return (
        <div className="flex justify-start">
          <Typography variant="p3" color="var(--navi-color-gray-c2)" className={styles.reportName}>
            {getReportTypeDisplayName(data?.baseReportType)}
          </Typography>
        </div>
      );
    }
  },
  {
    accessorKey: 'teamType',
    header: 'Team',
    size: 180,
    cell: ({ row }) => {
      const data = row.original;
      return (
        <div className="flex justify-start">
          <Typography variant="p3" color="var(--navi-color-gray-c2)">
            {getTeamTypeDisplayName(data?.teamType)}
          </Typography>
        </div>
      );
    }
  },
  {
    accessorKey: 'lastModifiedAt',
    header: 'Last Updated',
    size: 160,
    cell: ({ row }) => {
      const data = row.original;
      const formattedDate = data?.lastModifiedAt
        ? dayjs(utcToIST(data.lastModifiedAt)).format(DateFormat.DD_MMM_hh_mm_A)
        : '-';
      return (
        <div className="flex justify-start items-start flex-col">
          <Typography variant="h4" color="var(--navi-color-gray-c2)">
            {data?.lastModifiedBy || '-'}
          </Typography>
          <Typography variant="h6" color="var(--navi-color-navigation-blue-c3)">
            {formattedDate}
          </Typography>
        </div>
      );
    }
  },
  {
    accessorKey: 'actions',
    header: 'Actions',
    size: 100,
    cell: ({ row }) => {
      const data = row.original;
      return (
        <div className="flex items-center gap-2">
          <Button variant="text" onClick={() => onView(data)}>
            View
          </Button>
        </div>
      );
    }
  }
];
